module.exports = __webpack_public_path__ + "img/ico_group_plus.6ac8246b.svg";